import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    '& .dialog': {
      '&-title': {
        '&-container': {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: theme.spacing(0, 2, 0, 3),
          minHeight: theme.spacing(8),
        },
      },
      '&-content': {
        background: theme.palette.custom.background.app,
        padding: theme.spacing(0),
      },
      '&-question': {
        '&-container': {
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          padding: theme.spacing(3),
          outline: 'none',
        },
        '&-title': {
          display: 'flex',
          marginBottom: theme.spacing(1),
          fontWeight: theme.typography.fontWeightMedium,
          color: theme.palette.text.secondary,
        },
        '&-input': {
          width: '100%',
        },
      },
      '&-actions': {
        '&-container': {
          justifyContent: 'space-between',
          padding: theme.spacing(2, 2),
          flexWrap: 'wrap',
        },
        '&-pagination': {
          margin: theme.spacing(1),
          fontWeight: theme.typography.fontWeightMedium,
          color: theme.palette.text.secondary,
        },
        '&-btn': {
          '&-prev': {
            color: theme.palette.text.hint,
            marginRight: theme.spacing(2),
          },
        },
      },
    },
  },
  input: {
    background: theme.palette.custom.background.area,
  },
}));

export default styles;
